<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
  <nav class="" id="vy_header ">
    <h1  v-on:click="home" style="cursor:pointer">
    
        <img id="by-logo" src="../../images/logo.png" alt="ボラ活エール" />
    </h1>
    <div class="container">

    </div>
  </nav>
</template>

<script setup>
/* eslint-disable */
import { useRouter,useRoute } from 'vue-router'
import { login_check } from '../js/userdata_shakyo.js';
const router = useRouter();
let route = useRoute()
const cityname = route.params.shakyo
login_check()

//------------------------------ リンク --------------------------------
const home = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    router.push('/'+cityname+'/Kanri')
}
/*
const toiawase = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    //router.push('/Shakyo/toiawase')
}
const login = function() {
    //document.getElementById("vy_responsive_menu_close").click();
	login_check()
    router.push('/Shakyo/MailLogin')
}
const log_out = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    logout(); router.go('/Shakyo');
}
*/


let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/17bc0be34f8f80c9899bf966b87e0584?v=8fc1109df997461f978906bdc6784408"
    window.open(url,"_blank")
}
</script>
<style scoped>

</style>


